import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { privateRequest } from "services/privateRequest";
import { CUSTOMER } from 'services/endPoints';

export const fetchSupport = createAsyncThunk('support/getOptions', async () => {
  try {
    const response = await privateRequest.get("/support");
    console.log(response.data);
  } catch (error) {
    throw error.response.data;
  }
})

export const sendSupport = createAsyncThunk('support/sendSupport', async (params) => {
  try {
    const response = await privateRequest.post("api/support", params);
    // console.log(response.data);
    toast.success(response.data.message || "Issue reported")
  } catch (error) {
    throw error.response.data;
  }
})

export const requestType = createAsyncThunk(
  "support/requestType",
  async (params, { rejectWithValue }) => {
    try {
      const response = await privateRequest.get("/api/support-request", params);
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || "Request failed");
    }
  }
);

export const projectType = createAsyncThunk(
  "support/projectType",
  async (params, { rejectWithValue }) => {
    const { queryParams, append = false } = params;
    try {
      const response = await privateRequest.get(`${CUSTOMER}/projects`, { params: queryParams });
      return {
        data: response.data?.data?.data || [],
        total: response.data?.data?.count?.total || 0,
        append
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || "Request failed");
    }
  }
);

const initialState = {
  requestTypeOptions: [],
  projectTypeOptions: [],
  projectTotal: 0,
  hasMoreProjects: true,
};

const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupport.pending, (state, action) => {

      })
      .addCase(fetchSupport.fulfilled, (state, action) => {

      })
      .addCase(fetchSupport.rejected, (state, action) => {

      })
      .addCase(requestType.fulfilled, (state, action) => {
        state.requestTypeOptions = action.payload
      })
      .addCase(projectType.pending, (state, action) => {
        // Only clear if not appending
        if (!action.meta.arg.append) {
          state.projectTypeOptions = [];
        }
      })
      .addCase(projectType.fulfilled, (state, action) => {
        const { data, total, append } = action.payload;
        if (append) {
          state.projectTypeOptions = [...state.projectTypeOptions, ...data];
        } else {
          state.projectTypeOptions = data;
        }
        state.projectTotal = total;
        state.hasMoreProjects = state.projectTypeOptions.length < total;
      })
      .addCase(projectType.rejected, (state, action) => {
        if (!action.meta.arg.append) {
          state.projectTypeOptions = [];
        }
      })

  }
})

export default supportSlice.reducer